<template>
    <views class="empty">
        <views class="empty-content">
            <views class="desc">
                <images :src="warn"></images>
                没有符合您的抽奖活动
            </views>
            <button @click="handleHome">返回首页</button>
        </views>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    data() {
        return {
            warn: require('@/assets/images/warn.png')
        }
    },
    mounted() {
        // 禁止滚动
        document.body.addEventListener('touchmove', this.handler, { passive: false })
        document.body.addEventListener('wheel', this.handler, { passive: false })
    },
    destroyed() {
        // 移除禁止滚动
        document.body.removeEventListener('touchmove', this.handler, { passive: false })
        document.body.removeEventListener('wheel', this.handler, { passive: false })
    },
    methods: {
        handleHome() {
            this.push('/')
        },
        handler() {
            event.preventDefault()
            event.stopPropagation()
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
